// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__DVceY","copyright":"Contacts_copyright__sibhY"};